<template>
  <div class="d-flex flex-column mt-3">
    <!-- v-b-toggle="`${areaManager.sso_id}-${task.id}`" -->
    <div
      v-b-toggle="`${areaManager.id}-${task.activity_id}`"
      class="d-flex gap-3 cursor-pointer"
    >
      <div class="d-flex flex-column flex-grow-1 gap-1">
        <span
          class="font-weight-bold text-dark"
          style="font-size: 0.8rem;"
        >
          {{ task.activity?.activity_name }}
        </span>
        <div class="flex-grow-1 d-flex flex-column justify-content-end gap-1 mt-2">
          <div
            class="d-flex justify-content-between"
            style="font-size: 0.7rem;"
          >
            <div>
              <b class="text-muted">{{ task.events_count }}</b> of <b class="text-muted">{{ task.event_plan }}</b>
            </div>
            <div>
              <b :class="`text-${eventVariant}`">{{ eventProgress.toFixed(2) }}%</b>
            </div>
          </div>
          <BProgress
            :max="task.total"
            height="0.5rem"
          >
            <BProgressBar
              :value="eventProgress"
              :variant="eventVariant"
            />
          </BProgress>
        </div>
      </div>
      <div class="d-flex align-items-end">
        <i class="far fa-chevron-down" />
      </div>
    </div>
    <BCollapse
      :id="`${areaManager.id}-${task.activity_id}`"
      :accordion="`${areaManager.id}-${task.activity_id}`"
      role="tabpanel"
    >
      <div class="py-2">
        <AreaManagerTasks
          :activity="{
            total_buyers: task.customers_bought_count
          }"
          :current-progress="{
            customer: task.customers_attended_count,
            hectare: task.total_actual_hectares,
            cost: task.total_actual_costs,
            sales: task.total_actual_sales
          }"
          :total-progress="{
            customer: task.total_customer_plan,
            hectare: task.total_hectare_plan,
            cost: task.total_budget_plan,
            sales: task.total_sales_plan
          }"
        />
      </div>
    </BCollapse>
  </div>
</template>
<script>
import AreaManagerTasks from './AreaManagerTasks.vue'

export default {
  name: 'VAuditDashboardAreaManager',

  components: {
    AreaManagerTasks
  },

  props: {
    areaManager: {
      type: Object,
      required: true
    },
    task: {
      type: Object,
      required: true
    }
  },

  computed: {
    eventProgress () {
      const events = this.task.events_count / this.task.event_plan
      if (isNaN(events) || !isFinite(events)) {
        return 0
      }

      return events * 100
    },

    eventVariant () {
      if (this.eventProgress >= 75) {
        return 'success'
      } else if (this.eventProgress >= 31) {
        return 'warning'
      } else if (this.eventProgress >= 0.01) {
        return 'danger'
      } else {
        return 'dark'
      }
    }
  }
}
</script>
